import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueAMap from 'vue-amap'; //注意不要和 AMap原始名称覆盖

import border from "../com/border";
import aMap from "../com/map";
import moment from 'moment';
import { mojiForecast } from '@/api/api';
import { getAction } from '@/api/manage';
var amapManager = new VueAMap.AMapManager();
export default {
  name: 'atmosphere',
  components: {
    border: border,
    aMap: aMap
  },
  data: function data() {
    return {
      weather: [],
      cloudImgObj: {
        infraredImg: '',
        moistureImg: '',
        stereoscopicImg: ''
      }
    };
  },
  mounted: function mounted() {
    this.handleWeather(); //天气情况获取

    this.getCloudImg(); //气象云图获取
  },
  methods: {
    onToJump: function onToJump() {
      window.open('http://www.nmc.cn/publish/satellite/FY4A-true-color.htm');
    },
    handleWeather: function handleWeather() {
      var _this = this;

      var param = {
        lat: 22.839437,
        lon: 115.376810
      };
      var day_zh = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      mojiForecast(param).then(function (res) {
        console.log('res', res);

        if (res.success) {
          res.result.forecast.forEach(function (item) {
            item.week = day_zh[moment(item.predictDate).day()];
            item.date = moment(item.predictDate).format('MM/DD');
            if (item.date == moment().format('MM/DD')) item.date = '今天';else if (item.date == moment().add(1, 'days').format('MM/DD')) item.date = '明天';
          });
          _this.weather = res.result.forecast;
        }
      });
    },
    getCloudImg: function getCloudImg() {
      var _this2 = this;

      getAction("/sys/moji/nephogram").then(function (res) {
        if (res.success) {
          var cloudImgObj = _this2.cloudImgObj;
          cloudImgObj.infraredImg = res.result.infrared ? res.result.infrared : '';
          cloudImgObj.moistureImg = res.result.moisture ? res.result.moisture : '';
          cloudImgObj.stereoscopicImg = res.result.stereoscopic ? res.result.stereoscopic : '';
        }
      });
    }
  }
};